import { render } from "./WorkbooksV2.vue?vue&type=template&id=e686d6c0&scoped=true"
import script from "./WorkbooksV2.vue?vue&type=script&lang=js"
export * from "./WorkbooksV2.vue?vue&type=script&lang=js"

import "./WorkbooksV2.vue?vue&type=style&index=0&id=e686d6c0&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e686d6c0"],['__file',"src/views/post/WorkbooksV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e686d6c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e686d6c0', __exports__)) {
    console.log('reload')
    api.reload('e686d6c0', __exports__)
  }
  
  module.hot.accept("./WorkbooksV2.vue?vue&type=template&id=e686d6c0&scoped=true", () => {
    console.log('re-render')
    api.rerender('e686d6c0', render)
  })

}


export default __exports__